import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedVehicleCorrectiveImagesFormTabsParamsType,
  GetDamagedVehicleCorrectiveImagesFormTabsResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImagesFormTabs/getDamagedVehicleCorrectiveImagesFormTabs.type';

export const getInitialVisitCorrectiveImagesFormTabsFunction = (
  params: GetDamagedVehicleCorrectiveImagesFormTabsParamsType,
): Promise<GetDamagedVehicleCorrectiveImagesFormTabsResponseType> =>
  fetchApi.get(
    `/initial/reports/${params.id}/images/corrective/form/entry_tabs/`,
  );
